import React from 'react';

import i18n from 'util/i18n';
import { isPVQForm } from 'helpers/form';
import { IDENTIFICATION } from 'config/formSections/identification';

import SectionIntro from 'components/Section/shared/SectionIntro';
import connectSubsection from 'components/Section/shared/SubsectionConnector';

const Intro = function (props) {
  const isPVQ = isPVQForm(props.formType);
  const pvq = isPVQ ? '.pvq' : '';
  return (
    <SectionIntro
      title={i18n.t(`identification${pvq}.intro.title`)}
      body={i18n.m(`identification${pvq}.intro.body`)}
      sectionKey={IDENTIFICATION.key}
    />
  );
};

export default connectSubsection(Intro, {});
